import {
	BannerAlert,
	BannerAlertProps,
} from '../../../../libraries/design/components/banner-alert/src/banner-alert.tsx';

const UniformBannerAlert = (props: BannerAlertProps) => {
	return (
		<BannerAlert
			{...props}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'linkButton',
				'data-event-container': 'bannerAlert',
				'data-event': 'clicked',
			}}
		/>
	);
};

export default UniformBannerAlert;
